"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icon = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle"
});

var rest = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle",

  marginLeft: 64
});

var title = (0, _glamor.css)({
  display: "block",

  color: _css.colors.white,
  lineHeight: 1.3,
  fontWeight: 300,

  marginTop: (0, _css.unitRem)(0.25),
  marginBottom: (0, _css.unitRem)(0.25)
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.2,
    medium: 1.125,
    large: [1.125, 1.5]
  }
}));

var buttons = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(-0.25)
});

var buttonCss = (0, _glamor.css)({
  ":not(:first-child):before": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",

    width: 1,
    height: (0, _css.unitRem)(0.6),

    marginRight: (0, _css.unitRem)(0.5),

    background: _css.colors.gray
  }
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallLarge: [0.9, 1]
  }
}));

var download = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle",

  position: "absolute",
  right: 0,

  padding: (0, _css.unitRem)(0.5) + " 0"
});

var ProductRelease = function ProductRelease(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: icon },
      props.icon
    ),
    _react2.default.createElement(
      "div",
      { className: rest },
      _react2.default.createElement(
        "span",
        { className: !props.titleStyle ? title : props.titleStyle },
        props.title
      ),
      _react2.default.createElement(
        "div",
        { className: buttons },
        props.buttons.map(function (button) {
          return _react2.default.createElement(_TextButton2.default, (0, _extends3.default)({
            className: (0, _glamor.css)(buttonCss, props.titleLinkStyle)
          }, button, {
            mode: "small"
          }));
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: download },
      _react2.default.createElement(_Button2.default, {
        label: props.download.label,
        mode: "secondary",
        href: props.download.url,
        onClick: props.download.onClick
      })
    )
  );
};

exports.default = ProductRelease;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Mixer/Components/ProductRelease.jsx
// module id = 1279
// module chunks = 0